/* pn-audit-sept.js — ROUND 2 (Sept 28 2026)
   PDP "Added to your cart" mini-drawer (#pdpCart in pn-pdp.liquid): when the cart is under half-way
   to the free-shipping threshold, show the informational line ("Free shipping on orders over $1,250")
   instead of "you're $1,192 away". Mirrors the Liquid change in snippets/free-shipping-bar.liquid.
   Self-contained; safe if the elements never exist. */
(function () {
  function threshold() {
    var usd = false;
    try { usd = window.Shopify && Shopify.currency && Shopify.currency.active === 'USD'; } catch (e) {}
    return usd ? '$850 USD' : '$1,250 CAD';
  }
  function fix() {
    var t = document.getElementById('pdpFsTxt'), f = document.getElementById('pdpFsFill');
    if (!t || !f) return;
    if (!/away from/i.test(t.textContent)) return;
    var pct = parseFloat(String(f.style.width || '0').replace('%', '')) || 0;
    if (pct < 50) {
      t.innerHTML = '<b>Free shipping</b> on orders over <b>' + threshold() + '</b>';
    }
  }
  var mo = new MutationObserver(function () { fix(); });
  function arm() {
    var t = document.getElementById('pdpFsTxt');
    if (t) { mo.observe(t, { childList: true, characterData: true, subtree: true }); fix(); }
    var f = document.getElementById('pdpFsFill');
    if (f) { mo.observe(f, { attributes: true, attributeFilter: ['style'] }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();

/* R5-1: the search drawer's "Quiz — Which stool is right for me?" tool still points at /pages/stool-quiz,
   which is unpublished (404). Route it to the live profession picker. (Search drawer lives in sections/search-drawer.liquid.) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href="/pages/stool-quiz"]').forEach(function (a) { a.setAttribute('href', '/pages/saddle-stools'); });
});
